import React, { useEffect, useState } from "react";
import { adminApi, fmtPoints } from "../../lib/api";
import { Search } from "lucide-react";

export default function AdminCustomers() {
    const [items, setItems] = useState([]);
    const [q, setQ] = useState("");
    const [busy, setBusy] = useState(false);

    const load = () => {
        setBusy(true);
        adminApi.get(`/api/admin/customers?q=${encodeURIComponent(q)}`).then((r) => {
            setItems(r.data.customers);
            setBusy(false);
        });
    };
    useEffect(load, []); // eslint-disable-line

    return (
        <div>
            <h1 className="font-display text-3xl font-bold">Customers</h1>
            <div className="flex gap-2 items-center fx-input max-w-md mt-4">
                <Search size={16} className="text-[#6b7280]" />
                <input
                    data-testid="admin-customer-search"
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && load()}
                    placeholder="Search mobile, name, loyalty ID"
                    className="flex-1 bg-transparent outline-none"
                />
                <button onClick={load} className="text-[#c9a959] text-sm">Search</button>
            </div>

            <div className="fx-card mt-5 overflow-hidden">
                <table className="w-full text-sm">
                    <thead className="text-left text-xs uppercase tracking-widest text-[#9ca3af] border-b border-[rgba(11,20,55,0.10)]">
                        <tr>
                            <th className="px-4 py-3">Name</th>
                            <th className="px-4 py-3">Mobile</th>
                            <th className="px-4 py-3">Loyalty ID</th>
                            <th className="px-4 py-3">Tier</th>
                            <th className="px-4 py-3 text-right">Points</th>
                            <th className="px-4 py-3">Joined</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((c) => (
                            <tr key={c.id} className="border-b border-[rgba(11,20,55,0.05)] hover:bg-white/[0.03]">
                                <td className="px-4 py-3">{c.name || "—"}</td>
                                <td className="px-4 py-3 font-mono text-xs">+{c.mobile}</td>
                                <td className="px-4 py-3 font-mono text-xs">{c.loyalty_id}</td>
                                <td className="px-4 py-3">
                                    <span className="fx-chip bg-[#f9fafb] text-[#4b5563] border border-[rgba(11,20,55,0.10)]">
                                        {c.tier}
                                    </span>
                                </td>
                                <td className="px-4 py-3 text-right text-[#c9a959] font-semibold">
                                    {fmtPoints(c.wallet?.points_balance || 0)}
                                </td>
                                <td className="px-4 py-3 text-xs text-[#6b7280]">
                                    {new Date(c.created_at).toLocaleDateString("en-IN")}
                                </td>
                            </tr>
                        ))}
                        {!busy && items.length === 0 && (
                            <tr>
                                <td colSpan={6} className="px-4 py-10 text-center text-[#9ca3af]">
                                    No customers
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
